import { lazyLoad } from '@/lib/LazyLoad';

export const DiscordPage = lazyLoad(
  () => import('./DiscordPage'),
  (module) => module.DiscordPage
);
